import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';

@Component({
  selector: 'app-image-task-setup',
  templateUrl: './image-task-setup.component.html',
  styleUrls: ['./image-task-setup.component.scss']
})
export class ImageTaskSetupComponent implements OnInit {
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows
  };
  engagementId: any = "";
  engagementType: any = "";
  createEngagementFlag: boolean = true;
  whitelistFlag: boolean = false;
  wizardName: any = "Whitelist"
  localData: any;
  localFlagsData: any;
  whitelistObj:any
  zoneData:any =[];

  constructor(
    private wizardService: NgWizardService,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) {
    this.localFlagsData = JSON.parse(localStorage.getItem('engagementStepFlags'))
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
  }

  ngOnInit() {
    if(this.localData.is_edit){
      this.createEngagementFlag = this.localFlagsData.createEngagementFlag
      this.whitelistFlag = this.localFlagsData.whitelistFlag
      this.engagementId = this.localData.task_id
      this.engagementType = this.localData.engagement_type_id
      this.engagementCreated(true)
    } 
  }

  getEngagementId(e) {
    console.log(e)
    this.engagementId = e
  }

  getEngagementTypeId(e) {
    console.log(e)
    this.engagementType = e
  }

  engagementCreated(e) {
    console.log(e)
    this.whitelistFlag = true;
    setTimeout(() => {
      this.wizardService.next();
    }, 500)
  }

  getWhitelistObj(e){
    this.whitelistObj = e
    this.fetchZoneTypeData(e.zn_type)
  }

   fetchZoneTypeData(zone_type){
      if(zone_type==1){
        this.apiService.get(this.apiConfig.configGetRegion).subscribe((res)=>{
          this.zoneData = res['data'].region
          console.log("regionData",this.zoneData);
        })
      }
      if(zone_type==2){
        this.apiService.get(this.apiConfig.configGetStates).subscribe((res)=>{
          this.zoneData = res['data'].state;
          console.log("SateData",this.zoneData);
        })
      }
      if(zone_type==3){
        this.apiService.get(this.apiConfig.configGetCities).subscribe((res)=>{
          this.zoneData = res['data'].cities;
          console.log("cityData",this.zoneData);
        })
      }
  }

  whiteListed(e) {
    console.log(e)
    setTimeout(() => {
      this.wizardService.next();
    }, 500)
  }


  previous(): void {
    this.wizardService.previous();
  }

  next(): void {
    this.wizardService.next();
  }

  submit(): void {
    alert('Form submitted');
  }

  onStepChanged(args: StepChangedArgs): void {
    console.log(args.step);
  }

  onStepValidated(args: StepValidationArgs): void {
    console.log(args.toStep);
    console.log(args.direction);
  }



  ngDoCheck() {
    if (this.localData.has_subtask == 1) {
      this.wizardName = "Sub Task"
    } else {
      this.wizardName = "Whitelist"
    }
  }
}
